export default {
    data() {
        return {
            genreList: [
                'African',
                'Black Gospel',
                'Bluegrass',
                'Blues & R&B',
                'Brazilian',
                'Christmas',
                'Classical',
                'Comedy',
                'Country',
                'Easy Listening',
                'Electronic',
                'Folk',
                'Funk',
                'International',
                'Jazz',
                'Latin',
                'Metal',
                'New Age',
                'Oldies',
                'Polka',
                'Punk/New Wave',
                'Rap/Hip-Hop',
                'Reggae',
                'Religious',
                'Rock & Pop',
                'Rockabilly',
                'Soul',
                'Soundtrack & Cast',
                'Southern Gospel',
                'Special Interest',
                'Spoken Word',
                'Sturtz',
                'Vocal Groups',
                'Vocalists',
            ]
        }
    }
}